<script>
    import { __, getLanguageDirection } from '@oat-sa-private/ui-core';

    /**
     * Inline component for displaying MatchSet constraints
     * on row and column headers of a Match Interaction
     *
     * @property {number} matchMin - minimum constraint
     * @property {number} matchMax - maximum constraint
     * @property {number} usageCount - the number being validated against constraints
     * @property {boolean} showMin - for disabling min display
     * @property {boolean} showMax - for disabling max display
     * @property {string} lang - for disabling max display
     */
    // prettier-ignore
    let {
        matchMin = 0,
        matchMax = 0,
        usageCount = 0,
        showMin = true,
        showMax = true,
        lang
    } = $props();

    let doShowMin = $derived(showMin && matchMin > 0);
    let doShowMax = $derived(showMax && matchMax > 0);

    let underUsed = $derived(matchMin > 0 && usageCount < matchMin);
    let overUsed = $derived(matchMax > 0 && usageCount > matchMax);
    let dir = $derived(lang ? getLanguageDirection(lang) : void 0);
</script>

<style>
    .constraints {
        & span {
            font-size: var(--fontsize-body-xs);
            font-weight: normal;
            color: var(--color-text-feedback);

            &.invalid {
                color: var(--color-alert);
            }
        }
    }

    :global([data-layouts~='hideFeedbacksLayout']) {
        & .constraints {
            display: none;
        }
    }
</style>

<div class="constraints" {lang} {dir}>
    {#if doShowMax || doShowMin}
        <span class="visually-hidden">{__('constraints:')}</span>
    {/if}
    {#if doShowMin}
        <span class:invalid={underUsed}>
            {__('min %d', matchMin)}
        </span>
    {/if}
    {#if doShowMax}
        <span class:invalid={overUsed}>
            {__('max %d', matchMax)}
        </span>
    {/if}
</div>
